import {useEffect, useState} from 'react'

import * as Yup from 'yup'
import {useLazyAcademicFilterQuery, useAddStudentMutation} from '../../../Api/allApi'
import {Button} from 'primereact/button'
import UpdateIcon from '@mui/icons-material/Update'
import UploadIcon from '@mui/icons-material/Upload'
import DownloadIcon from '@mui/icons-material/Download'
import SearchIcon from '@mui/icons-material/Search'
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt'

import {InputText} from 'primereact/inputtext'

import {Divider} from 'primereact/divider'

import {Dropdown, DropdownChangeEvent} from 'primereact/dropdown'

import {Dialog} from 'primereact/dialog'
import DatatableSkeleton from './DatatableSkeleton'
import AddEditStudentModal from './AddEditStudentModal'
import StudentCardSkeleton from './StudentCardSkeleton'

export default function StudentLists() {
  const [showAddEditStudentDialog, setShowAddEditStudentDialog] = useState<boolean>(false)
  const [filterData, setFilterData]: any = useState({
    stream: [],
    streamId: 0,
    selectedStream: null,
    class: [],
    classId: 0,
    selectedClass: {value: '', label: ''},
    division: [],
    divisionId: 0,
    selectedDivision: {value: '', label: ''},
  })
  // filter api
  const [filterTrigger, result] = useLazyAcademicFilterQuery()
  const {isSuccess, isFetching} = result

  useEffect(() => {
    filterTrigger({})
  }, [filterTrigger])

  // when api calling is done successfully
  useEffect(() => {
    if (isSuccess && !isFetching) {
      const data = result?.data
      console.log(data)
      let streams = data.stream?.map((item) => {
        return {value: item?.dbId, label: item?.name}
      })
      setFilterData((prevData) => {
        return {
          ...prevData,
          stream: streams,
        }
      })
    }
  }, [isSuccess, isFetching, result?.data])

  const handleStreamSelect = (e) => {
    console.log(e)
    const streamData: any = filterData?.stream?.find((_: any) => _?.value === e.value)
    const classData = result.data.class[e.value]
    const classObj =
      classData && classData.length > 0
        ? classData.map((item) => ({value: item.dbId, label: item.name}))
        : []

    const data = {
      ...filterData,
      streamId: e.value,
      selectedStream: {label: streamData.label, value: e.value},
      class: classObj,
      classId: 0,
      selectedClass: {value: '', label: ''},
      division: [],
      divisionId: 0,
      selectedDivision: {value: '', label: ''},
    }
    // console.log(data)
    setFilterData(data as any)
  }
  return (
    <>
      <div className='container gap-2 d-flex ps-0 mb-5'>
        <div className='card col-5 justify-content-center px-5'>
          <h3 className='card-title mb-4 ms-5'>Global Student Search</h3>

          <div className='p-inputgroup flex-1 border-none'>
            <InputText
              placeholder='Type to search'
              className='border-right-0 ps-5 fs-5 search-box'
              style={{
                borderTopLeftRadius: '3rem',
                borderBottomLeftRadius: '3rem',
              }}
            />
            <span
              className='p-inputgroup-addon bg-transparent'
              style={{
                borderTopRightRadius: '3rem',
                borderBottomRightRadius: '3rem',
              }}
            >
              <Button
                // size='large'
                icon={<SearchIcon fontSize='large' />}
                rounded
                severity='info'
                aria-label='Search'
                style={{
                  borderRadius: '100%',
                }}
              />
            </span>
          </div>
        </div>
        <div className='card col-7'>
          <div className='card-toolbar col d-flex gap-3 justify-content-end me-5'>
            <Button
              label='Complete Profiles'
              rounded
              severity='info'
              icon={<UpdateIcon fontSize='large' />}
              style={{
                borderRadius: '1rem',
              }}
              // onClick={() => {
              //   document?.getElementById('fileInput')?.click()
              // }}
              className='flex-column my-4 col-2 gap-2 fs-5'
            />
            <Button
              label='Add Students'
              rounded
              severity='info'
              icon={<PersonAddAltIcon fontSize='large' />}
              style={{
                borderRadius: '1rem',
              }}
              onClick={() => setShowAddEditStudentDialog(true)}
              className='flex-column my-4 col-2 gap-2 fs-5'
            />
            <Button
              label='Upload Data'
              rounded
              severity='info'
              icon={<UploadIcon fontSize='large' />}
              style={{
                borderRadius: '1rem',
              }}
              // onClick={() => {
              //   document?.getElementById('fileInput')?.click()
              // }}
              className='flex-column my-4 col-2 gap-2 fs-5'
            />
            <Button
              label='Download Data'
              rounded
              severity='info'
              icon={<DownloadIcon fontSize='large' />}
              style={{
                borderRadius: '1rem',
              }}
              // onClick={() => {
              //   sampleDownload({})
              // }}
              className='flex-column my-4 col-2 gap-2 fs-5'
            />

            <Button
              label='Download Sample'
              rounded
              severity='info'
              icon={<DownloadIcon fontSize='large' />}
              style={{
                borderRadius: '1rem',
              }}
              // onClick={() => {
              //   sampleDownload({})
              // }}
              className='flex-column my-4 col-2 gap-2 fs-5'
            />
          </div>
        </div>
      </div>
      <div className='container gap-2 d-flex ps-0'>
        <div className='card col-9 pb-0'>
          <h3 className='card-title mt-4 mb-5 ms-5'>Browse Student</h3>
          <div className='ms-5 mb-5 col-md-4'>
            {/* <label className='form-label'>
              Select Stream<span className='text-danger'>*</span>
            </label> */}
            <Dropdown
              value={filterData?.selectedStream?.value}
              options={filterData?.stream}
              onChange={(e: DropdownChangeEvent) => {
                handleStreamSelect(e)
              }}
              optionLabel='label'
              placeholder='Select a Stream'
              className='w-100'
            />

            {/* end::Menu 2 */}
          </div>
          <div className='col pb-5 d-flex flex-column align-items-center px-5'>
            <DatatableSkeleton />
            <Divider className='w-90' />
            <DatatableSkeleton />
            <Divider />
            <DatatableSkeleton />
            <Divider />
            <DatatableSkeleton />
            <Divider />
            <DatatableSkeleton />
            <Divider />
            <DatatableSkeleton />
            <Divider />
            <DatatableSkeleton />
          </div>
        </div>
        <div className='card col-3 justify-content-center'>
          <h3 className='card-title mt-4 ms-5 mb-8'>Last Added Students</h3>
          <div className='col px-5'>
            <StudentCardSkeleton />
            <StudentCardSkeleton />
            <StudentCardSkeleton />
            <StudentCardSkeleton />
          </div>
        </div>
      </div>
      <Dialog
        visible={showAddEditStudentDialog}
        header='Add Student'
        position='top'
        onHide={() => {
          if (!showAddEditStudentDialog) return
          setShowAddEditStudentDialog(false)
        }}
        draggable={false}
        resizable={false}
        style={{width: '75vw'}}
      >
        <AddEditStudentModal />
      </Dialog>
    </>
  )
}
